import React from 'react'
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from '../../components/table/TableOps';
import { AuthContext } from "../../context/authContext";
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import EADLog from './EADLog';
import EADCancel from './EADCancel';
import EADIncumplida from './EADIncumplida';
import ACCESS from '../../ACCESS';

const EAD_MODALS = {
   LOG: 100,
   CANCEL: 101,
   INCUMPLIDA: 102,
}

class EADList extends TableComponent {

   componentDidMount() {
      let acciones = [
         { id: 'edit', icon: 'edit', tooltip: 'Editar', access: [ACCESS.CITAS_EAD.EDITAR_CITAS_CLIENTE, ACCESS.CITAS_EAD.EDITAR_CITAS_SUCURSAL, ACCESS.CITAS_EAD.EDITAR_CITAS_TODAS, ACCESS.CITAS_EAD.EDITAR_CITAS_USUARIO] },
         { id: 'log', icon: 'history', tooltip: 'Ver historial de cambios', access: [ACCESS.CITAS_EAD.VER_HISTORIAL] },
         { id: 'incumplida', icon: 'alarm_off', tooltip: 'Marcar como incumplida', access: [ACCESS.CITAS_EAD.MARCAR_INCUMPLIDA] },
         { id: 'cancel', icon: 'cancel', tooltip: 'Marcar como cancelada', access: [ACCESS.CITAS_EAD.MARCAR_CANCELADA] },
      ];

      this.tableConfig(
         { dataUrl: 'ead/list', deleteUrl: '', deleteField: '', modUrl: '/EAD/Edit', key: 'folio_ead' },
         TableOp.Table('Citas EAD', [
            { label: 'Folio Cita', id: 'folio_ead' },
            { label: 'Fecha Cita', id: 'fecha_ead' },
            { label: 'Estatus Cita', id: 'status_ead' },
            { label: 'Detalle', id: 'concepto' },
            { label: 'Guia', id: 'g_folio' },
            { label: 'Cliente', id: 'cliente' },
            { label: 'Estatus de la Guia', id: 'status_guia' },

         ], acciones))
      this.table();
   }

   action = (id, row, cb) => {
      if ([2, 3].includes(row.id_status) && 'log' !== id) {
         return
      }
      if (id === 'edit') {
         this.props.history.push(`${this.config.modUrl}/${row.id}`)
      } else if ('log' === id) {
         this.setState({ selectedRow: row, modal: EAD_MODALS.LOG });
      } else if('cancel' === id) {
         this.setState({ selectedRow: row, modal: EAD_MODALS.CANCEL });
      } else if('incumplida' === id) {
         this.setState({ selectedRow: row, modal: EAD_MODALS.INCUMPLIDA });
      }
   }

   onCancelEAD = () => {
      this.table()
      this.setState({ modal: null });
   }

   render() {
      const { modal = null, selectedRow } = this.state;
      const { hasAccess } = this.context;
      return (
         <div style={{ margin: 10 }} >

            <div style={{
               display: 'flex',
               width: '100%',
               justifyContent: 'flex-end',
               padding: 5,
            }} >
               <Button
                  variant='contained'
                  onClick={() => { this.props.history.push(`/EAD/Edit/Create`); }}
                  color='primary'>
                  {`Nueva Cita`}
               </Button>
            </div>
            <this.TableRender />

            {/** Modal de historial EAD */}
            <Dialog
               maxWidth='md'
               open={modal === EAD_MODALS.LOG}
               onClose={() => this.setState({ modal: null })}
            >
               <DialogContent>
                  {selectedRow && (<EADLog id={selectedRow.id} />)}
               </DialogContent>
               <DialogActions>
                  <Button onClick={() => this.setState({ modal: null })} color="primary">
                     Cerrar
                  </Button>
               </DialogActions>
            </Dialog>

            {/** Modal de cancel EAD/INCUMPLIDA */}
            <Dialog
               maxWidth='md'
               open={[EAD_MODALS.CANCEL, EAD_MODALS.INCUMPLIDA].includes(modal)}
               onClose={() => this.setState({ modal: null })}
            >
               <DialogContent>
                  {  EAD_MODALS.CANCEL === modal &&  <EADCancel id={selectedRow.id}  onClose={() => this.setState({ modal: null })}  onCancel={this.onCancelEAD}/> }
                  {  EAD_MODALS.INCUMPLIDA === modal &&  <EADIncumplida id={selectedRow.id}  onClose={() => this.setState({ modal: null })}  onCancel={this.onCancelEAD}/> }
               </DialogContent>
            </Dialog>

         </div>
      )
   }
}

EADList.contextType = AuthContext;
export default withRouter(EADList);